!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.timerInterval = null, this.daysMap = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6
      };
    }
    connectedCallback() {
      this.defaultText = this.getAttribute("data-default-text") || "", this.countdownTextTemplate = this.getAttribute("data-countdown-text") || "", 
      this.cutoffTime = this.getAttribute("data-cutoff-time") || "19:00";
      const t = this.getAttribute("data-excluded-days") || "";
      this.excludedDays = t.toLowerCase().split(",").map(t => this.daysMap[t.trim()]).filter(t => void 0 !== t);
      const e = this.getAttribute("data-excluded-dates") || "";
      this.excludedDates = e.split(",").map(t => t.trim()).filter(t => t), this.startCountdown();
    }
    disconnectedCallback() {
      this.timerInterval && clearInterval(this.timerInterval);
    }
    isExcluded(t) {
      if (this.excludedDays.includes(t.getDay())) return !0;
      const e = t.getFullYear() + "-" + String(t.getMonth() + 1).padStart(2, "0") + "-" + String(t.getDate()).padStart(2, "0");
      return !!this.excludedDates.includes(e);
    }
    t(t, e) {
      if (!window.strings || !window.strings.date_time || !window.strings.date_time[t]) return `${e} ${t}`;
      return (1 === e ? window.strings.date_time[t].one : window.strings.date_time[t].other).replace("{{ count }}", e);
    }
    startCountdown() {
      const t = () => {
        const t = new Date, e = new Date(t.getFullYear(), t.getMonth(), t.getDate(), this.cutoffTime.split(":")[0], this.cutoffTime.split(":")[1], 0, 0), s = e - t;
        if (!e || this.isExcluded(t) || isNaN(s) || s <= 0) return this.disconnectedCallback(), 
        this.innerHTML = this.defaultText, this.classList.remove("hidden"), !1;
        const i = 6e4, n = 36e5, a = 864e5, d = Math.floor(s / a), r = Math.floor(s % a / n), o = Math.floor(s % n / i), l = Math.floor(s % i / 1e3);
        let u = [];
        o < 1 ? u.push(this.t("second", l)) : (d > 0 && u.push(this.t("day", d)), (r > 0 || d > 0) && u.push(this.t("hour", r)), 
        u.push(this.t("minute", o)));
        const h = u.join(" "), c = this.countdownTextTemplate.replace("{countdown}", `<span>${h}</span>`);
        this.innerHTML = c, this.classList.remove("hidden");
      };
      t(), this.timerInterval = setInterval(t, 1e3);
    }
  }
  customElements.define("delivery-countdown", t);
}();